import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SetCurrentApp } from '@app/core/states/app.actions';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { ResponsiveState } from '@app/core/states/responsive.state';
import { Store } from '@ngxs/store';
import { filter, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'rk-statistics-shell',
  standalone: false,
  templateUrl: './statistics-shell.component.html',
  styleUrl: './statistics-shell.component.scss',
})
export class StatisticsShellComponent implements OnInit, OnDestroy {
  showAppManagerMobileWarning$: Observable<boolean> = inject(Store).select(
    ResponsiveState.showAppManagerMobileWarning,
  );
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly subscriptions: Subscription = new Subscription();

  ngOnInit() {
    // event tracking
    this.store.dispatch(
      new SetEventProperties({
        name: 'PageStatisticsDashboard',
        component: 'Page',
      }),
    );
    this.store.dispatch(new LogEvent('Page Viewed'));

    // get route parameters
    this.subscriptions.add(
      this.route?.params.pipe(filter(params => !!params)).subscribe(params => {
        const appId = params['appId'];
        if (appId) {
          this.store.dispatch(new SetCurrentApp(appId));
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
